import { render, staticRenderFns } from "./customerMgt.vue?vue&type=template&id=46cc3174&scoped=true&"
import script from "./customerMgt.vue?vue&type=script&lang=js&"
export * from "./customerMgt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cc3174",
  null
  
)

export default component.exports